const globalSettings = require("@2kog/pkg-common/data/global.json");
module.exports = {
    // document title
    Title: "User Center",
    TitleSuffix: "2KOG",

    API: {},

    // Token
    tokenKey: "RX_Token",
    tokenExpires: 2592000000, // 30 days

    // CDN
    __cdn: globalSettings.__cdn,
    __static: globalSettings.__static,
};
